import React from "react"

import "./index.scss"
import { Title, Container, Text } from "components/Form"
import { convertTokenDisplay } from "utils/scripts/adminHelpers"
import useT from "utils/hooks/useT"

export default function UsageConfig({ item }) {
  const { t } = useT("common")
  const tokenCounts = item.token_counts
  const hasAssets = "assetCount" in item && typeof item.assetCount === "number"
  const hasTokens = tokenCounts?.current_month && tokenCounts?.previous_month
  const hasSeats =
    ("seatsUsed" in item && typeof item.seatsUsed === "number") ||
    ("seatsTotal" in item && typeof item.seatsTotal === "number")

  return (
    <div>
      {hasAssets && (
        <div className="container-compartment">
          <p>{t("assets")}</p>
          <Container>
            <Title>{t("used")}</Title>
            <Text disabled value={String(item.assetCount)} />
          </Container>
        </div>
      )}
      {hasSeats && (
        <div className="container-compartment">
          <p>{t("seats")}</p>
          <Container>
            <Title>{t("total")}</Title>
            <Text disabled value={String(item.seatsTotal)} />
          </Container>
          {typeof item.freeSeatsTotal === "number" && (
            <Container>
              <Title>{t("viewOnly")}</Title>
              <Text disabled value={String(item.freeSeatsTotal)} />
            </Container>
          )}
        </div>
      )}
      {hasTokens && (
        <div className="container-compartment">
          <p>{t("tokens")}</p>
          <Container>
            <Title width="160px">{t("inputThisMonth")}</Title>
            <Text disabled value={convertTokenDisplay(tokenCounts.current_month.input)} />
          </Container>
          <Container>
            <Title width="160px">{t("outputThisMonth")}</Title>
            <Text disabled value={convertTokenDisplay(tokenCounts.current_month.output)} />
          </Container>
          <Container>
            <Title width="160px">{t("inputLastMonth")}</Title>
            <Text disabled value={convertTokenDisplay(tokenCounts.previous_month.input)} />
          </Container>
          <Container>
            <Title width="160px">{t("outputLastMonth")}</Title>
            <Text disabled value={convertTokenDisplay(tokenCounts.previous_month.output)} />
          </Container>
        </div>
      )}
    </div>
  )
}
